import React from "react";
import { AttestatiPage } from "../../components/attestati";

export default function CertificatesPage() {
  return (<AttestatiPage />);
}
